module.exports = __webpack_public_path__ + "static/img/9c.c3570fb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/9c.jpg
// module id = cf5/
// module chunks = 0